import z from '@/lib/zod';

/**
 * Parametri di filtro nell'URL. L'indirizzo si scrive anche a mano o arriva
 * da un link vecchio: un valore inatteso diventa "nessun filtro" invece di
 * far cadere la rotta sulla validazione.
 *
 * Stringa: il router rilegge come numero o booleano un `3` o un `true`
 * scritti senza virgolette, mentre le combobox hanno id stringa.
 */
export const optionalSearchString = () =>
  z.coerce.string().nullish().catch(undefined);

export const optionalSearchBoolean = () =>
  z.boolean().nullish().catch(undefined);

/**
 * Intero: il router rilegge `year=2026` come numero; una stringa (anche il
 * vecchio `year=%222026%22` fra virgolette) si converte, il resto si scarta.
 */
export const optionalSearchInteger = () =>
  z.coerce.number().int().optional().catch(undefined);
